export const CHAT = "CHAT";
export const TASK_DETAILS = "TASK_DETAILS";

export const AI_TUTOR_TAB_OPTIONS = [
  {
    label: "common:create",
    value: CHAT,
  },
  {
    label: "common:configure",
    value: TASK_DETAILS,
  },
];
